/** Names of the tabs inside the ColumnsConfigurationButton popover */
export enum ColumnConfigurationTab {
  Personal = 'personal',
  Organization = 'organization',
}

/** Maximum length of the dynamic column within the ColumnConfiguration button */
export const DYNAMIC_COLUMN_LENGTH = 35;
